import * as d3 from 'd3';
import BarChart from './lib/BarChart';
import StackedBubbleChart from './lib/StackedBubbleChart';
import ForceLayout from './lib/ForceLayout';
import getData from './provider';
import { flatten, formatNumber } from './lib/utils';

const tooltip = [...document.querySelectorAll('.tooltip')];
const tipoCirculo = document.getElementById('tipo-circulo');
const rankingWrapper = document.getElementById('ranking-wrapper');
const funesTiposTotalesWrapper = document.getElementById('funes-tipos-totales-filters');
let rankingWrapperBtn = rankingWrapper.querySelector('.button.is-active');
let funesTiposTotalesWrapperBtn = funesTiposTotalesWrapper.querySelector('.button.is-active');

const axisTooltips = [
  {
    axisText: 'Obras de infraestructura',
    tooltipText: 'Construcción, reconstrucción, remodelación, mejoramiento, demolición, renovación, ampliación y habilitación de bienes inmuebles, tales como edificaciones, estructuras, excavaciones, perforaciones, carreteras, puentes, entre otros, que requieren dirección técnica, expediente técnico, mano de obra, materiales y/o equipos.',
  },
  {
    axisText: 'Servicios',
    tooltipText: 'Actividad o labor que requiere una Entidad para el desarrollo de sus actividades y el cumplimiento de sus funciones y fines.',
  },
  {
    axisText: 'Bienes',
    tooltipText: 'Son objetos que requiere una Entidad para el desarrollo de sus actividades y el cumplimiento de sus funciones y fines.',
  },
  {
    axisText: 'Consultoría de Obras',
    tooltipText: 'Servicios que consisten en la elaboración del expediente técnico de obras, en la supervisión de la elaboración de expediente técnico de obra o en la supervisión de obras.',
  },
];

const store = {
  funes_ranking: null,
  funes_tipos_totales: null,
  tipo_proceso_osce: null,
  exoneraciones: null,
  charts: {
    first_bubbles: null,
    first_bars: null,
    first_bars_key: null,
    second: null,
    third_bubbles: null,
    third_bars: null,
    fourth_bubbles: null,
    fourth_bars: null,
  },
};

function renderFirstChart(type) {
  const data = store.tipo_proceso_osce[type];

  // Bubble decorator
  const bubblesMouseOverHandler = (bubbles) => {
    // eslint-disable-next-line no-param-reassign
    bubbles.handleMouseOver = (datum) => {
      bubbles.tooltip
        .html(`
          <p style="margin-bottom: 0.25rem">${datum.texto}</p>
          <span>Monto total: S/.${formatNumber(datum.amount)}
        `)
        .show();
    };
  };

  // Bars Decorator
  const barsTooltipHandler = (barchart) => {
    // eslint-disable-next-line no-param-reassign
    barchart.handleMouseOver = (datum) => {
      const hasExtraInfo = axisTooltips.map((a) => a.axisText).includes(datum.nombre);
      const amount = `S/. ${formatNumber(datum.monto)}`;
      if (hasExtraInfo) {
        const info = axisTooltips.find((a) => a.axisText === datum.nombre).tooltipText;
        barchart.tooltip
          .html(`
            <p>${info}</p>${amount}
          `)
          .show();
        return;
      }
      barchart.tooltip
        .html(`
          <p class="block md:hidden">${datum.nombre}</p>
          ${amount}
        `)
        .show();
    };
  };

  const bubblesClickHandler = (bubbles) => {
    // eslint-disable-next-line no-param-reassign
    bubbles.handleClick = (datum) => {
      if (!datum) {
        funesTiposTotalesWrapper.style.display = 'none';
        tipoCirculo.textContent = '';
        store.charts.first_bars.delete();
        store.charts.first_bars = null;
        return;
      }
      funesTiposTotalesWrapper.style.display = 'flex';
      // Update button
      funesTiposTotalesWrapperBtn.classList.remove('is-active');
      funesTiposTotalesWrapperBtn = funesTiposTotalesWrapper.querySelector('button');
      funesTiposTotalesWrapperBtn.classList.add('is-active');
      // Store the key
      store.charts.first_bars_key = datum.key;
      // Update title
      tipoCirculo.textContent = datum.type_text;

      if (!store.charts.first_bars) {
        store.charts.first_bars = new BarChart({
          target: '#funes-tipos-totales-bars',
          data: store.funes_ranking[datum.key].entidades.PEN,
          vars: {
            num: 'monto',
            cat: 'nombre',
          },
          plot: {
            tooltip: true,
            mode: 'square',
            colorPalette: '#8ab9c4',
            margin: {
              top: 10, right: 0, bottom: 10, left: 250,
            },
          },
        });
        barsTooltipHandler(store.charts.first_bars);
        store.charts.first_bars.draw();
        return;
      }
      barsTooltipHandler(store.charts.first_bars);
      store.charts.first_bars.setData(store.funes_ranking[datum.key].entidades.PEN);
      store.charts.first_bars.update();
    };
  };

  store.charts.first_bubbles = new StackedBubbleChart({
    data,
    target: '#funes-tipos-totales-bubbles',
    vars: {
      num: 'amount',
      label: 'porcentaje',
      legend: 'categoria',
    },
    plot: {
      colorPalette: '#c381bc',
    },
  });
  bubblesMouseOverHandler(store.charts.first_bubbles);
  bubblesClickHandler(store.charts.first_bubbles);
  store.charts.first_bubbles.draw();
}

/* Second chart */
function renderSecondChart(type) {
  const data = store.funes_ranking.osce[type].PEN;
  const barsTooltipHandler = (barchart) => {
    // eslint-disable-next-line no-param-reassign
    barchart.handleMouseOver = (datum) => {
      barchart.tooltip
        .html(`
          <p class="block md:hidden">${datum.nombre}</p>
          <p style="text-align: center">S/.${formatNumber(datum.monto)}</p>
        `)
        .show();
    };
  };

  store.charts.second = new BarChart({
    data,
    target: '#funes-ranking',
    vars: {
      num: 'monto',
      cat: 'nombre',
    },
    plot: {
      tooltip: true,
      colorPalette: '#6F67A1',
      margin: {
        top: 10, right: 0, bottom: 10, left: 250,
      },
    },
  });
  barsTooltipHandler(store.charts.second);
  store.charts.second.draw();
}

/* Third chart */
function renderThirdChart(type) {
  const contractType = document.getElementById('tipo-contrato-1');
  const data = store.funes_tipos_totales[type];
  const totalAmount = d3.sum(data, (d) => d.total);
  const detailsOnly = flatten(data.map((item) => item.detalle));

  const detailsByProcessType = d3.nest()
    .key((d) => d.tipo_proceso)
    .rollup((v) => {
      const total = d3.sum(v, (d) => d.monto);
      return {
        total,
        percentageOverTotal: (total * 100) / totalAmount,
        tooltip: v[0].tooltip,
      };
    })
    .entries(detailsOnly)
    .map((item) => ({
      ...item,
      key: item.key,
      percentageOverTotal: item.value.percentageOverTotal,
      total: item.value.total,
    }))
    .sort((a, b) => b.percentageOverTotal - a.percentageOverTotal);

  // Bars Decorator
  const barsTooltipHandler = (barchart) => {
    // eslint-disable-next-line no-param-reassign
    barchart.handleMouseOver = (datum) => {
      const tip = datum.value ? datum.value.tooltip : null;
      barchart.tooltip
        .html(`
          <p>${tip || datum.key}</p>
          <span>${d3.format('.2%')(parseFloat(datum.percentageOverTotal) / 100)} - S/. ${formatNumber(datum.total)}</span>
        `)
        .show();
    };
  };

  // Bubble Decorator
  const bubblesClickHandler = (bubbles) => {
    // eslint-disable-next-line no-param-reassign
    bubbles.handleClick = (datum) => {
      if (!datum) {
        contractType.textContent = '';
        store.charts.third_bars.setData(detailsByProcessType);
        store.charts.third_bars.update();
        return;
      }
      contractType.textContent = `- ${datum.name}`;
      const bubble = data.find((d) => d.nombre === datum.name);
      const scopedData = bubble.detalle.map((b) => ({
        key: b.tipo_proceso,
        total: b.monto,
        percentageOverTotal: (b.monto * 100) / bubble.total,
      })).sort((a, b) => b.percentageOverTotal - a.percentageOverTotal);
      store.charts.third_bars.setData(scopedData);
      store.charts.third_bars.update();
    };
  };

  store.charts.third_bubbles = new ForceLayout({
    target: '#funes-tipo-proceso-bubbles',
    data,
    vars: {
      num: 'total',
      cat: 'nombre',
    },
    plot: {
      colorPalette: ['#d4e6f0', '#bfd9e8', '#aacce1', '#9ac0d8', '#8ab4ce', '#7ba9c5', '#6e9ebc', '#6093b3', '#5488aa', '#497ea0', '#3e7497', '#346a8e', '#2b6184', '#23587b', '#1b4f72'].reverse(),
      radiusRatio: 1 / 6,
    },
  });
  bubblesClickHandler(store.charts.third_bubbles);
  store.charts.third_bubbles.draw();

  store.charts.third_bars = new BarChart({
    target: '#funes-tipo-proceso-bars',
    data: detailsByProcessType,
    vars: {
      num: 'percentageOverTotal',
      cat: 'key',
    },
    plot: {
      tooltip: true,
      colorPalette: '#dfeab7',
      margin: {
        top: 10, right: 0, bottom: 10, left: 250,
      },
      domain: [0, 100],
      mode: 'square',
    },
  });
  barsTooltipHandler(store.charts.third_bars);
  store.charts.third_bars.draw();
}

/* Fourth chart */
function renderFourthChart(type) {
  const contractType = document.getElementById('tipo-contrato-2');
  const data = store.exoneraciones[type];
  const totalAmount = d3.sum(data, (d) => d.total);
  const detailsOnly = flatten(data.map((item) => item.detalle));

  const exoneraciones = detailsOnly
    .filter((d) => d.tipo_proceso === 'Contratación Directa y Exoneración')
    .map((d) => d.monto)
    .sort((a, b) => b - a);

  const detailsByProcessType = d3.nest()
    .key((d) => d.tipo_proceso)
    .rollup((v) => {
      const total = d3.sum(v, (d) => d.monto);
      return {
        total,
        percentageOverTotal: (total * 100) / totalAmount,
        tooltip: v[0].tooltip,
      };
    })
    .entries(detailsOnly)
    .map((item) => ({
      ...item,
      key: item.key,
      percentageOverTotal: item.value.percentageOverTotal,
      total: item.value.total,
    }))
    .sort((a, b) => b.percentageOverTotal - a.percentageOverTotal);

  // Bars Decorator
  const barsTooltipHandler = (barchart) => {
    // eslint-disable-next-line no-param-reassign
    barchart.handleMouseOver = (datum) => {
      const tip = datum.value ? datum.value.tooltip : null;
      barchart.tooltip
        .html(`
          <p>${tip || datum.key}</p>
          <span>${d3.format('.2%')(parseFloat(datum.percentageOverTotal) / 100)} - S/. ${formatNumber(datum.total)}</span>
        `)
        .show();
    };
  };

  // Bubble Decorator
  const bubblesClickHandler = (bubbles) => {
    // eslint-disable-next-line no-param-reassign
    bubbles.handleClick = (datum) => {
      if (!datum) {
        contractType.textContent = '';
        store.charts.fourth_bars.setData(detailsByProcessType);
        store.charts.fourth_bars.update();
        return;
      }
      contractType.textContent = `- ${datum.nombre}`;
      const bubble = data.find((d) => d.nombre === datum.name);
      const scopedData = bubble.detalle.map((b) => ({
        key: b.tipo_proceso,
        total: b.monto,
        percentageOverTotal: (b.monto * 100) / bubble.total,
      })).sort((a, b) => b.percentageOverTotal - a.percentageOverTotal);
      store.charts.fourth_bars.setData(scopedData);
      store.charts.fourth_bars.update();
    };
  };

  store.charts.fourth_bubbles = new ForceLayout({
    target: '#exoneraciones-bubbles',
    data,
    vars: {
      num: 'total',
      cat: 'nombre',
    },
    plot: {
      colorPalette: ['#d4e6f0', '#bfd9e8', '#aacce1', '#9ac0d8', '#8ab4ce', '#7ba9c5', '#6e9ebc', '#6093b3', '#5488aa', '#497ea0', '#3e7497', '#346a8e', '#2b6184', '#23587b', '#1b4f72'].reverse(),
      radiusRatio: 1 / 6,
      domain: [0, d3.max(exoneraciones)],
    },
  });
  bubblesClickHandler(store.charts.fourth_bubbles);
  store.charts.fourth_bubbles.draw();

  store.charts.fourth_bars = new BarChart({
    target: '#exoneraciones-bars',
    data: detailsByProcessType,
    vars: {
      num: 'percentageOverTotal',
      cat: 'key',
    },
    plot: {
      tooltip: true,
      colorPalette: '#dfeab7',
      margin: {
        top: 10, right: 0, bottom: 10, left: 250,
      },
      domain: [0, 100],
      mode: 'square',
    },
  });
  barsTooltipHandler(store.charts.fourth_bars);
  store.charts.fourth_bars.draw();
}

window.onload = () => {
  getData()
    .then(([funesRanking, funesTiposTotales, tipoProcesoOsce, exoneracionesDirectas]) => {
      store.funes_ranking = funesRanking;
      store.funes_tipos_totales = funesTiposTotales;
      store.tipo_proceso_osce = tipoProcesoOsce;
      store.exoneraciones = exoneracionesDirectas;
      renderFirstChart('results_soles');
      renderSecondChart('empresas');
      renderThirdChart('contratista');
      renderFourthChart('contratista');
    });
};

/**
 * Events
 */

tooltip.forEach((t) => {
  t.addEventListener('click', function handleTooltipClick() {
    this.classList.toggle('visible');
  });
});

funesTiposTotalesWrapper.addEventListener('click', (event) => {
  if (!event.target.matches('button')) {
    return;
  }

  const { type } = event.target.dataset;
  const key = store.charts.first_bars_key;

  funesTiposTotalesWrapperBtn.classList.remove('is-active');
  funesTiposTotalesWrapperBtn = event.target;
  funesTiposTotalesWrapperBtn.classList.add('is-active');

  store.charts.first_bars.setData(store.funes_ranking[key][type].PEN);
  store.charts.first_bars.update();
});

rankingWrapper.addEventListener('click', (event) => {
  if (!event.target.matches('button')) {
    return;
  }
  const type = event.target.id;

  rankingWrapperBtn.classList.remove('is-active');
  rankingWrapperBtn = event.target;
  rankingWrapperBtn.classList.add('is-active');

  store.charts.second.setData(store.funes_ranking.osce[type].PEN);
  store.charts.second.update();
});

window.addEventListener('resize', () => {
  if (store.charts.first_bars) {
    store.charts.first_bars.resize();
  }
  store.charts.second.resize();
  store.charts.third_bubbles.resize();
  store.charts.third_bars.resize();
  store.charts.fourth_bubbles.resize();
  store.charts.fourth_bars.resize();
});
